import PropTypes from 'prop-types';
import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';

import { messages } from '../../constants/Collection';
import { GridConstants } from '../../constants/Grid';
import { PandoraTypes } from '../../constants/SourceTypes';
import { getArt, getDominantColor } from '../../lib/ArtUtils';
import { getAnnotationsById } from '../../lib/EntityUtils';
import { isRadioOnly, isUnavailable } from '../../lib/RightsUtils';
import {
  getCurrentPathnameFromState,
  getMyMusicArtistPath,
  isBackstagePath,
} from '../../lib/RouteUtils';
import { getSourceCardMenuItems } from '../../lib/SourceCardUtils';

import CatalogGridItem from './CatalogGridItem';

/**
 * ArtistGridItem is for rendering T3 artist grid items.
 *
 * See CatalogGridItem and lib/GridItem for additional available props.
 */
class ArtistGridItem extends React.Component {
  static propTypes = {
    id: PropTypes.string,
    pandoraType: PropTypes.string,
    mainText: PropTypes.string,
    mainTextUrl: PropTypes.string,
    itemOnclickUrl: PropTypes.string,
    sourceCardMenuItems: PropTypes.array,
    intl: PropTypes.object,
  };

  static defaultProps = {
    pandoraType: PandoraTypes.ARTIST,
  };

  render() {
    return (
      <CatalogGridItem
        isCircle={true}
        hoverText={this.props.intl.formatMessage(messages.artistViewMusic)}
        {...this.props}
      />
    );
  }
}

export function mapStateToProps(state, ownProps) {
  const props = {};
  const id = ownProps.id;
  const details = getAnnotationsById(state, id);
  props.blankItem = !details;
  if (details && id) {
    props.mainText = details.get('name');
    const shareableUrlPath = details.get('shareableUrlPath');
    const pathname = getCurrentPathnameFromState(state);
    const myMusicArtistPath = getMyMusicArtistPath(pathname, details);
    props.mainTextUrl = isBackstagePath(pathname) ? shareableUrlPath : myMusicArtistPath;
    props.itemOnclickUrl = isBackstagePath(pathname) ? shareableUrlPath : myMusicArtistPath;
    props.imgUrl = getArt(details, GridConstants.GRID_ITEM_IMAGE_SIZE, state);
    props.isRadioOnly = isRadioOnly(details);
    props.isUnavailable = isUnavailable(details);
    props.explicitness = details.get('explicitness');
    props.dominantColor = getDominantColor(details);
    props.sourceCardMenuItems = getSourceCardMenuItems({
      state,
      pandoraId: id,
      pandoraType: PandoraTypes.ARTIST,
      shareParentSource: {
        shareParentSourceId: id,
        shareParentSourceType: PandoraTypes.ARTIST,
      },
    });
  }
  return props;
}

// We use injectIntl here because there was some inexplicable performance issues when using <FormattedMessage> directly in the props
export default injectIntl(connect(mapStateToProps, {})(ArtistGridItem));
